/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from 'componentregistry';

export const page: {
  root: Item<'Page'>;
  flexItem: Item<'FlexItem'>;
  tabPanel: Item<'TabPanel'>;
  flexItem1: Item<'FlexItem'>;
  flexItem2: Item<'FlexItem'>;
  flexItem3: Item<'FlexItem'>;
  flexItem5: Item<'FlexItem'>;
  flexPanel: Item<'FlexPanel'>;
  flexPanel1: Item<'FlexPanel'>;
  flexPanel2: Item<'FlexPanel'>;
  editTabItem: Item<'TabItem'>;
  listTabItem: Item<'TabItem'>;
  dashboardTabItem: Item<'TabItem'>;
  smartSearch: Item<'SmartSearch'>;
  canvasGrid: Item<'CanvasGrid'>;
  storeAliasLocalDataStore: Item<'LocalDataStore'>;
  storeAliasDataStoreReference: Item<'DataStoreReference'>;
  searchAttribute: Item<'SmartSearchAttribute'>;
  searchAttribute1: Item<'SmartSearchAttribute'>;
  searchAttribute2: Item<'SmartSearchAttribute'>;
  searchAttribute3: Item<'SmartSearchAttribute'>;
  searchAttribute4: Item<'SmartSearchAttribute'>;
  searchAttribute5: Item<'SmartSearchAttribute'>;
  searchAttribute6: Item<'SmartSearchAttribute'>;
  searchAttribute7: Item<'SmartSearchAttribute'>;
  searchAttribute8: Item<'SmartSearchAttribute'>;
  searchAttribute9: Item<'SmartSearchAttribute'>;
  idNumberColumn: Item<'NumberColumn'>;
  checkboxCheckboxColumn: Item<'CheckboxColumn'>;
  firstNameStringColumn: Item<'StringColumn'>;
  lastUpdateDateDateColumn: Item<'DateColumn'>;
  numberNumberColumn: Item<'NumberColumn'>;
  booleanCheckboxColumn: Item<'CheckboxColumn'>;
  creationDateDateColumn: Item<'DateColumn'>;
  createdByStringColumn: Item<'StringColumn'>;
  dateTimeDateColumn: Item<'DateColumn'>;
  lastUpdatedByStringColumn: Item<'StringColumn'>;
  storeAliasDataStoreReference1: Item<'DataStoreReference'>;
  form: Item<'Form'>;
  numberNumberField: Item<'NumberField'>;
  creationDateDateField: Item<'DateField'>;
  lastUpdateDateDateField: Item<'DateField'>;
  lastUpdatedByTextField: Item<'TextField'>;
  idNumberField: Item<'NumberField'>;
  firstNameTextField: Item<'TextField'>;
  createdByTextField: Item<'TextField'>;
  dateTimeDateField: Item<'DateField'>;
  booleanCheckbox: Item<'Checkbox'>;
  checkboxCheckbox: Item<'Checkbox'>;
} = {
  booleanCheckbox: {
    children: [],
    itemId: 'booleanCheckbox',
    parent: 'form',
    props: {
      label: { type: 'text', value: 'Boolean' },
      viewAttribute: 'boolean',
    },
    type: 'Checkbox',
  },
  booleanCheckboxColumn: {
    children: [],
    itemId: 'booleanCheckboxColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Boolean' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'boolean',
      width: 80,
    },
    type: 'CheckboxColumn',
  },
  canvasGrid: {
    children: [
      'idNumberColumn',
      'createdByStringColumn',
      'lastUpdatedByStringColumn',
      'creationDateDateColumn',
      'lastUpdateDateDateColumn',
      'firstNameStringColumn',
      'numberNumberColumn',
      'dateTimeDateColumn',
      'booleanCheckboxColumn',
      'checkboxCheckboxColumn',
    ],
    itemId: 'canvasGrid',
    parent: 'flexItem3',
    props: {},
    type: 'CanvasGrid',
  },
  checkboxCheckbox: {
    children: [],
    itemId: 'checkboxCheckbox',
    parent: 'form',
    props: {
      label: { type: 'text', value: 'Checkbox' },
      viewAttribute: 'checkbox',
    },
    type: 'Checkbox',
  },
  checkboxCheckboxColumn: {
    children: [],
    itemId: 'checkboxCheckboxColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Checkbox' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'checkbox',
      width: 80,
    },
    type: 'CheckboxColumn',
  },
  createdByStringColumn: {
    children: [],
    itemId: 'createdByStringColumn',
    parent: 'canvasGrid',
    props: {
      label: { type: 'text', value: 'Created By' },
      viewAttribute: 'createdBy',
      width: 200,
    },
    type: 'StringColumn',
  },
  createdByTextField: {
    children: [],
    itemId: 'createdByTextField',
    parent: 'form',
    props: {
      insertable: {
        type: 'boolean',
        value: false,
      },
      label: { type: 'text', value: 'Created By' },
      updatable: {
        type: 'boolean',
        value: false,
      },
      viewAttribute: 'createdBy',
    },
    type: 'TextField',
  },
  creationDateDateColumn: {
    children: [],
    itemId: 'creationDateDateColumn',
    parent: 'canvasGrid',
    props: {
      label: { type: 'text', value: 'Creation Date' },
      showTime: true,
      viewAttribute: 'creationDate',
      width: 120,
    },
    type: 'DateColumn',
  },
  creationDateDateField: {
    children: [],
    itemId: 'creationDateDateField',
    parent: 'form',
    props: {
      insertable: {
        type: 'boolean',
        value: false,
      },
      label: { type: 'text', value: 'Creation Date' },
      showTime: true,
      updatable: {
        type: 'boolean',
        value: false,
      },
      viewAttribute: 'creationDate',
    },
    type: 'DateField',
  },
  dashboardTabItem: {
    children: ['flexPanel'],
    itemId: 'dashboardTabItem',
    parent: 'tabPanel',
    props: {
      icon: {
        iconName: 'chart-line',
        iconType: 'light',
      },
      indicatorColor: 'success',
      label: {
        type: 'text',
        value: 'Dashboard',
      },
    },
    type: 'TabItem',
  },
  dateTimeDateColumn: {
    children: [],
    itemId: 'dateTimeDateColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Date Time' },
      showTime: true,
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'dateTime',
      width: 120,
    },
    type: 'DateColumn',
  },
  dateTimeDateField: {
    children: [],
    itemId: 'dateTimeDateField',
    parent: 'form',
    props: {
      label: { type: 'text', value: 'Date Time' },
      showTime: true,
      viewAttribute: 'dateTime',
    },
    type: 'DateField',
  },
  editTabItem: {
    children: ['storeAliasDataStoreReference1'],
    itemId: 'editTabItem',
    parent: 'tabPanel',
    props: {
      icon: {
        iconName: 'edit',
        iconType: 'light',
      },
      indicatorColor: 'warning',
      label: {
        type: 'text',
        value: 'Edit',
      },
    },
    type: 'TabItem',
  },
  firstNameStringColumn: {
    children: [],
    itemId: 'firstNameStringColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'First Name' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'firstName',
      width: 200,
    },
    type: 'StringColumn',
  },
  firstNameTextField: {
    children: [],
    itemId: 'firstNameTextField',
    parent: 'form',
    props: {
      label: { type: 'text', value: 'First Name' },
      viewAttribute: 'firstName',
    },
    type: 'TextField',
  },
  flexItem: {
    children: [],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexItem1: {
    children: [],
    itemId: 'flexItem1',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexItem2: {
    children: ['smartSearch'],
    itemId: 'flexItem2',
    parent: 'flexPanel1',
    props: {
      sizeType: 'auto',
    },
    type: 'FlexItem',
  },
  flexItem3: {
    children: ['canvasGrid'],
    itemId: 'flexItem3',
    parent: 'flexPanel1',
    props: {},
    type: 'FlexItem',
  },
  flexItem5: {
    children: ['form'],
    itemId: 'flexItem5',
    parent: 'flexPanel2',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem', 'flexItem1'],
    itemId: 'flexPanel',
    parent: 'dashboardTabItem',
    props: {},
    type: 'FlexPanel',
  },
  flexPanel1: {
    children: ['flexItem2', 'flexItem3'],
    itemId: 'flexPanel1',
    parent: 'storeAliasDataStoreReference',
    props: {},
    type: 'FlexPanel',
  },
  flexPanel2: {
    children: ['flexItem5'],
    itemId: 'flexPanel2',
    parent: 'storeAliasDataStoreReference1',
    props: {},
    type: 'FlexPanel',
  },
  form: {
    children: [
      'idNumberField',
      'createdByTextField',
      'lastUpdatedByTextField',
      'creationDateDateField',
      'lastUpdateDateDateField',
      'firstNameTextField',
      'numberNumberField',
      'dateTimeDateField',
      'booleanCheckbox',
      'checkboxCheckbox',
    ],
    itemId: 'form',
    parent: 'flexItem5',
    props: {},
    type: 'Form',
  },
  idNumberColumn: {
    children: [],
    itemId: 'idNumberColumn',
    parent: 'canvasGrid',
    props: {
      allowDecimal: false,
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Id' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'id',
      width: 120,
    },
    type: 'NumberColumn',
  },
  idNumberField: {
    children: [],
    itemId: 'idNumberField',
    parent: 'form',
    props: {
      allowDecimal: false,
      label: { type: 'text', value: 'Id' },
      viewAttribute: 'id',
    },
    type: 'NumberField',
  },
  lastUpdateDateDateColumn: {
    children: [],
    itemId: 'lastUpdateDateDateColumn',
    parent: 'canvasGrid',
    props: {
      label: { type: 'text', value: 'Last Update Date' },
      showTime: true,
      viewAttribute: 'lastUpdateDate',
      width: 120,
    },
    type: 'DateColumn',
  },
  lastUpdateDateDateField: {
    children: [],
    itemId: 'lastUpdateDateDateField',
    parent: 'form',
    props: {
      insertable: {
        type: 'boolean',
        value: false,
      },
      label: { type: 'text', value: 'Last Update Date' },
      showTime: true,
      updatable: {
        type: 'boolean',
        value: false,
      },
      viewAttribute: 'lastUpdateDate',
    },
    type: 'DateField',
  },
  lastUpdatedByStringColumn: {
    children: [],
    itemId: 'lastUpdatedByStringColumn',
    parent: 'canvasGrid',
    props: {
      label: { type: 'text', value: 'Last Updated By' },
      viewAttribute: 'lastUpdatedBy',
      width: 200,
    },
    type: 'StringColumn',
  },
  lastUpdatedByTextField: {
    children: [],
    itemId: 'lastUpdatedByTextField',
    parent: 'form',
    props: {
      insertable: {
        type: 'boolean',
        value: false,
      },
      label: { type: 'text', value: 'Last Updated By' },
      updatable: {
        type: 'boolean',
        value: false,
      },
      viewAttribute: 'lastUpdatedBy',
    },
    type: 'TextField',
  },
  listTabItem: {
    children: ['storeAliasDataStoreReference'],
    itemId: 'listTabItem',
    parent: 'tabPanel',
    props: {
      icon: {
        iconName: 'list-alt',
        iconType: 'light',
      },
      label: {
        type: 'text',
        value: 'List',
      },
    },
    type: 'TabItem',
  },
  numberNumberColumn: {
    children: [],
    itemId: 'numberNumberColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Number' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'number',
      width: 120,
    },
    type: 'NumberColumn',
  },
  numberNumberField: {
    children: [],
    itemId: 'numberNumberField',
    parent: 'form',
    props: {
      label: { type: 'text', value: 'Number' },
      viewAttribute: 'number',
    },
    type: 'NumberField',
  },
  root: {
    children: ['storeAliasLocalDataStore', 'tabPanel'],
    itemId: 'root',
    parent: 'root',
    props: {
      backgroundColor: 'paper',
      windowTitle: {
        type: 'text',
        value: 'Blank Page',
      },
    },
    type: 'Page',
  },
  searchAttribute: {
    children: [],
    itemId: 'searchAttribute',
    parent: 'smartSearch',
    props: {
      attributeCode: 'createdBy',
      defaultOperator: 'is',
      label: 'Created By',
    },
    type: 'SmartSearchAttribute',
  },
  searchAttribute1: {
    children: [],
    itemId: 'searchAttribute1',
    parent: 'smartSearch',
    props: {
      attributeCode: 'boolean',
      dataType: 'Boolean',
      defaultOperator: 'isTrue',
      label: 'Boolean',
    },
    type: 'SmartSearchAttribute',
  },
  searchAttribute2: {
    children: [],
    itemId: 'searchAttribute2',
    parent: 'smartSearch',
    props: {
      attributeCode: 'firstName',
      defaultOperator: 'is',
      label: 'First Name',
    },
    type: 'SmartSearchAttribute',
  },
  searchAttribute3: {
    children: [],
    itemId: 'searchAttribute3',
    parent: 'smartSearch',
    props: {
      attributeCode: 'lastUpdateDate',
      dataType: 'Date',
      defaultOperator: 'after',
      label: 'Last Update Date',
    },
    type: 'SmartSearchAttribute',
  },
  searchAttribute4: {
    children: [],
    itemId: 'searchAttribute4',
    parent: 'smartSearch',
    props: {
      attributeCode: 'lastUpdatedBy',
      defaultOperator: 'is',
      label: 'Last Updated By',
    },
    type: 'SmartSearchAttribute',
  },
  searchAttribute5: {
    children: [],
    itemId: 'searchAttribute5',
    parent: 'smartSearch',
    props: {
      attributeCode: 'creationDate',
      dataType: 'Date',
      defaultOperator: 'after',
      label: 'Creation Date',
    },
    type: 'SmartSearchAttribute',
  },
  searchAttribute6: {
    children: [],
    itemId: 'searchAttribute6',
    parent: 'smartSearch',
    props: {
      attributeCode: 'dateTime',
      dataType: 'Date',
      defaultOperator: 'after',
      label: 'Date Time',
    },
    type: 'SmartSearchAttribute',
  },
  searchAttribute7: {
    children: [],
    itemId: 'searchAttribute7',
    parent: 'smartSearch',
    props: {
      attributeCode: 'id',
      dataType: 'Number',
      defaultOperator: 'eq',
      label: 'Id',
    },
    type: 'SmartSearchAttribute',
  },
  searchAttribute8: {
    children: [],
    itemId: 'searchAttribute8',
    parent: 'smartSearch',
    props: {
      attributeCode: 'number',
      dataType: 'Number',
      defaultOperator: 'eq',
      label: 'Number',
    },
    type: 'SmartSearchAttribute',
  },
  searchAttribute9: {
    children: [],
    itemId: 'searchAttribute9',
    parent: 'smartSearch',
    props: {
      attributeCode: 'checkbox',
      dataType: 'YN',
      defaultOperator: 'is',
      label: 'Checkbox',
    },
    type: 'SmartSearchAttribute',
  },
  smartSearch: {
    children: [
      'searchAttribute7',
      'searchAttribute',
      'searchAttribute4',
      'searchAttribute5',
      'searchAttribute3',
      'searchAttribute2',
      'searchAttribute8',
      'searchAttribute6',
      'searchAttribute1',
      'searchAttribute9',
    ],
    itemId: 'smartSearch',
    parent: 'flexItem2',
    props: {},
    type: 'SmartSearch',
  },
  storeAliasDataStoreReference: {
    children: ['flexPanel1'],
    itemId: 'storeAliasDataStoreReference',
    parent: 'listTabItem',
    props: {
      alias: 'storeAlias',
    },
    type: 'DataStoreReference',
  },
  storeAliasDataStoreReference1: {
    children: ['flexPanel2'],
    itemId: 'storeAliasDataStoreReference1',
    parent: 'editTabItem',
    props: {
      alias: 'storeAlias',
    },
    type: 'DataStoreReference',
  },
  storeAliasLocalDataStore: {
    children: [],
    itemId: 'storeAliasLocalDataStore',
    parent: 'root',
    props: {
      alias: 'storeAlias',
      dataFormat: 'json',
      dataSource: 'ChangeMe',
      jsonData:
        '[\n    {\n        "firstName": "John",\n        "number": 123.456,\n        "dateTime": "2022-02-02T22:10:09.276Z",\n        "boolean": true,\n        "checkbox": "Y"\n    }\n]',
      singleton: true,
    },
    type: 'LocalDataStore',
  },
  tabPanel: {
    children: ['dashboardTabItem', 'listTabItem', 'editTabItem'],
    itemId: 'tabPanel',
    parent: 'root',
    props: {},
    type: 'TabPanel',
  },
};
